import React__default from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { logSocialLoginEvent } from '../../data-layer/social-login.js';
import { useAdditionalLoginProviders } from '../../hooks/use-additional-login-providers.js';
import { SocialButton } from '../SocialButton/SocialButton.js';

const SocialLogin = ({ onLogin , returnPath , labels , className  })=>{
    const { isProviderEnabled  } = useAdditionalLoginProviders();
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('social-login', className)
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "social-login__buttons"
    }, isProviderEnabled('google') ? /*#__PURE__*/ React__default.createElement(SocialButton, {
        onClick: ()=>{
            logSocialLoginEvent({
                type: 'sign_in_google_click'
            });
            onLogin('google', returnPath);
        },
        socialProvider: "google",
        caption: labels.googleButton
    }) : null), labels.consent ? /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, labels.consent)) : null);
};

export { SocialLogin };
//# sourceMappingURL=SocialLogin.js.map
